import React, { useState } from 'react';
import './style.scss';

export interface UQAccordionProps {
  children: React.ReactNode;
  singleExpand?: boolean; // If true, only one item can be expanded at a time
  separatePanels?: boolean; // If true, display panels as separate cards
}

const UQAccordion: React.FC<UQAccordionProps> = ({ children, singleExpand = false, separatePanels = false }) => {
  const [expandedItems, setExpandedItems] = useState<{ [key: string]: boolean }>({});

  const handleToggle = (key: string) => {
    setExpandedItems((prev) => {
      if (singleExpand) {
        return { [key]: !prev[key] }; // Collapse all others
      }
      return { ...prev, [key]: !prev[key] }; // Toggle the clicked item
    });
  };

  return (
    <div className={`accordion ${separatePanels ? 'accordion-separate' : 'accordion-grouped'}`}>
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<{ isExpanded: boolean; onToggle: () => void }>, {
            isExpanded: expandedItems[index] || false,
            onToggle: () => handleToggle(index.toString()),
          });
        }
        return child;
      })}
    </div>
  );
};

export default UQAccordion;